module.exports = __webpack_public_path__ + "img/capacitor-teal.0f8485fc.png";